<template>
	<div class="c-image-gallery__item" :key="video.MediaUrl" :class="{ '-full-width' : fullWidth }" v-if="video.MediaUrl">
		<div class="c-image-gallery__fig-container" @click="showModal" @keydown.enter="showModal">
			<figure class="c-image-gallery__image-figure">
				<img class="c-image-gallery__image" :src="video.PlaceHolderImageUrl" alt="" height="300" width="300"/>
			</figure>
			<button class="c-image-gallery__play-btn">
				<span class="c-image-gallery__play-btn-label">
					Play
				</span>
			</button>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { trackedgNoTrackedVideoUrl } from "shared/services/urlTypeService";

export default {
	name: 'gallery-video',
	props: {
		video: {
			type: Object,
			required: true,
		},
		fullWidth: {
			type: Boolean,
			required: false,
			default: false,
		},
		index: {
			type: Number,
		}
	},
	data() {
		return {
			isPlaying: false
		}
	},
	computed: {
		...mapGetters({
			galleryImageModalVisible: 'getGalleryImagesModalVisible',
			cookieBotMarketingPermissions: 'getCookieBotMarketingPermissions',
		}),
		isVimeo() {
			return this.video.MediaUrl.indexOf('vimeo.com') !== -1;
		},
	},
	watch: {
		cookieBotMarketingPermissions(newVal) {
			//video link depends on cookie bot marketing permissions (if permissions is changed by pressing renew button in footer)
			this.video.MediaUrl = trackedgNoTrackedVideoUrl(this.isVimeo, newVal, this.video.MediaUrl);
		}
	},
	methods: {
		...mapMutations(
			['setGalleryImagesModalVisible', 'setGalleryImagesModalActiveIndex']
		),
		showModal() {
			const updateGalleryImageModalVisible = !this.getGalleryImagesModalVisible;

			this.setGalleryImagesModalActiveIndex(this.index);

			this.setGalleryImagesModalVisible(updateGalleryImageModalVisible);

			this.playVideo();
		},
		playVideo() {
			this.isPlaying = !this.isPlaying;

			this.$nextTick(() => {
				const videoPlayer = document.getElementById('galleryVideoPlayer' + this.index);

				if (!this.isVimeo) {
					let player = new YT.Player(videoPlayer, {
						events: {
							'onReady': (event) => {
								event.target.playVideo();
							},
						}
					});
				}
				else {
					let playerVimeo = new Vimeo.Player(videoPlayer);
					playerVimeo.on('loaded', () => {
						playerVimeo.play();
					});
				}
			});
		}
	},
	mounted() {
		//video link depends on cookie bot marketing permissions
		this.video.MediaUrl = trackedgNoTrackedVideoUrl(this.isVimeo, this.cookieBotMarketingPermissions, this.video.MediaUrl);
		// add youtube api support
		const tag = document.createElement('script');
		tag.id = this.isVimeo ? 'iframe-demo-vimeo' : 'iframe-demo';
		tag.src = this.isVimeo ? 'https://player.vimeo.com/api/player.js' : 'https://www.youtube.com/iframe_api';
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
}
</script>
